import { hubBody, hubRequest } from './client'

export const retryFailedNotifications = () => hubRequest<{ queued: number }>('/notifications/retry-failed', hubBody({}))
